import { render, staticRenderFns } from "./channel-preferences.vue?vue&type=template&id=d4643e76&scoped=true&"
import script from "./channel-preferences.vue?vue&type=script&lang=js&"
export * from "./channel-preferences.vue?vue&type=script&lang=js&"
import style0 from "./channel-preferences.vue?vue&type=style&index=0&id=d4643e76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4643e76",
  null
  
)

export default component.exports